import React, {Component} from 'react'
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {TextInput, Wizard} from "../../../components";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import DateUtil from "../../../utils/DateUtil";
import NabidhFormTextEnum from "../NabidhFormTextEnum";
import FormLanguages from "../enum/FormLanguages";
import moment from "moment";
import {isMinor} from "../../patient/Patient";
import DiscLogo from "../../../layout/DiscLogo";

export default class PublicNabidhConsentForm extends Component {
    constructor(props) {
        super(props);

        const form = props.form;
        this.state = {
            consentAction: form ? this.getConsentActionFromForm(form) : null
        };

        this.formFields = [];
    }

    getConsentActionFromForm(form) {
        return form.consentType || null;
    }

    createHeader = (form) => {
        const { language } = this.props;
        // Handle both string and object language props
        const selectedLanguage = typeof language === 'string' ? language : (language || FormLanguages.ENGLISH).name;
        const textEnum = NabidhFormTextEnum;

        return <div style={{ padding: "0px 20px 0px 20px" }}>
            <div className="row text-left">
                <div className="col-12 no-padding">
                    <DiscLogo />
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center no-padding" style={{ fontSize: 20, fontWeight: "bold" }}>
                    {textEnum.Nabidh_Consent_Form_Title[selectedLanguage]}
                </div>
            </div>
            <div className="row" style={{ fontSize: 11 }}>
                <div className="col-4 text-left no-padding">
                    <b>{textEnum.Patient_Name[selectedLanguage]}: </b> {form.patientFullName}
                </div>
                <div className="col-4 text-center no-padding">
                    <b>{textEnum.MRN[selectedLanguage]}: </b> {form.patientMrn}
                </div>
                <div className="col-4 text-right no-padding">
                    <b>{textEnum.DOB[selectedLanguage]}: </b> {DateUtil.formatDate(form.patientDOB)}
                </div>
            </div>
        </div>
    };

    fieldChanged = (fieldName, value) => {
        this.props.form[fieldName] = value;
        this.forceUpdate();
    };

    handleConsentActionChange = (value) => {
        const form = this.props.form;
        form.consentType = value;

        this.setState({
            consentAction: value
        });
    };

    close = () => {
        confirmDialog(
            'Confirmation',
            'Are you sure you want to close this form? All input will be lost.',
            this.props.close);
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const { consentFormCode: code, form, language } = this.props;

            RemotingService.postRemoteCall(`api/public/consent-form/code/${code}/nabidh-consent-form`, form);
            this.props.onFormSubmit(form);
        }
    };

    /**
     * Get patient name safely handling null or undefined values
     * @param {Object} form - Form object containing patient information
     * @returns {string} - Patient name or empty string if not available
     */
    getPatientName = (form) => {
        return form && form.patientFullName ? form.patientFullName : '';
    }

    getPatientDOB = (form) => {
        return form && form.patientDOB ? form.patientDOB : null;
    }

    /**
     * Get localized text based on the current language
     * @param {string} key - The key to look up in the text enum
     * @returns {string} - The localized text
     */
    getLocalizedText = (key) => {
        const { language } = this.props;
        // Handle both string and object language props
        const selectedLanguage = typeof language === 'string' ? language : (language || FormLanguages.ENGLISH).name;
        return NabidhFormTextEnum[key] ? NabidhFormTextEnum[key][selectedLanguage] : '';
    }

    render() {
        this.formFields = [];

        const form = this.props.form;

        // Handle both string and object language props
        const selectedLanguage = typeof this.props.language === 'string' ? this.props.language : (this.props.language || FormLanguages.ENGLISH).name;
        const patientName = this.getPatientName(form);
        const isPatientMinor = isMinor(this.getPatientDOB(form), 'UAE');
        const isArabic = selectedLanguage === 'Arabic';
        const textDirection = isArabic ? 'rtl' : 'ltr';
        const textAlign = isArabic ? 'right' : 'left';

        return (
            <Wizard
                show={true} fullScreen
                footerStyle={{ backgroundColor: '#f5f5f5' }}
                buttonStyle={{ backgroundColor: '#84BE56', border: 'none' }}
                header={this.createHeader(form)}
                close={this.close}
                onSubmit={this.submitForm}>

                {/* Page 1: Consent Acknowledgment Header and Statements 1-4 */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                    <div style={{ margin: "20px 20px 20px 20px", direction: textDirection, textAlign: textAlign }}>
                        {/* Consent Acknowledgment Header */}
                        <p style={{fontSize: isArabic ? '18px' : 'inherit', fontWeight: 'bold', marginBottom: '20px'}}>
                            {this.getLocalizedText('Consent_Acknowledgment_Header')}
                        </p>

                        {/* Consent Statement 1 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_1')}
                            </p>
                        </div>

                        {/* Consent Statement 2 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_2')}
                            </p>
                        </div>

                        {/* Consent Statement 3 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_3')}
                            </p>
                        </div>

                        {/* Consent Statement 4 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_4')}
                            </p>
                        </div>

                    </div>

                </Wizard.Page>

                {/* Page 2: Remaining Consent Statements and Signature Section */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ margin: "20px 20px 20px 20px", direction: textDirection, textAlign: textAlign }}>
                        {/* Consent Statement 5 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_5')}
                            </p>
                        </div>

                        {/* Consent Statement 6 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_6')}
                            </p>
                        </div>

                        {/* Consent Statement 7 */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Consent_Statement_7')}
                            </p>
                        </div>

                        <div className="container">
                            {/* Date Field */}
                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Date')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    {": " + moment(new Date(form.patientDate)).format('MMMM DD, YYYY')}
                                </div>
                            </div>

                            {/* Patient Name */}
                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Patient_Name')}
                                </div>
                                <div className="col-md-9 dim14-base-input">
                                    {": " + patientName}
                                </div>
                            </div>

                            {/* Guardian Name */}
                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Parent_Guardian_Name')}
                                </div>
                                <div className="col-md-9 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        required={false}
                                        requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={form.witnessName}>
                                        <TextInput value={form.witnessName} alphabeticOnly
                                            onChange={(value) => this.fieldChanged('witnessName', value)} />
                                    </FormField>
                                </div>
                            </div>

                            {/* Relationship to Patient */}
                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Guardian_Relationship')}
                                </div>
                                <div className="col-md-9 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        required={false}
                                        requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={form.relationshipToPatient}>
                                        <TextInput value={form.relationshipToPatient} alphabeticOnly
                                            onChange={(value) => this.fieldChanged('relationshipToPatient', value)} />
                                    </FormField>
                                </div>
                            </div>

                            {/* Patient Signature */}
                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Patient_Signature')}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                               required requiredMessage={this.getLocalizedText('Signature_Required')}
                                               validateOn={form.patientSignature}>
                                        <SignatureInput signature={form.patientSignature}
                                                        onClear={() => {
                                                            if (form) {
                                                                this.fieldChanged('patientSignature', null)
                                                            }
                                                        }}
                                                        onSave={(signature) => {
                                                            if (form) {
                                                                this.fieldChanged('patientSignature', signature)
                                                            }
                                                        }} />
                                    </FormField>
                                </div>
                            </div>
                        </div>

                        {/* Guardian Section Header */}
                        <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "15px", marginBottom: "10px" }}>
                            <p style={{fontSize: isArabic ? '18px' : 'inherit', margin: 0}}>
                                {this.getLocalizedText('Guardian_Section_Header')}
                            </p>
                        </div>

                        <div className="container">
                            {/* Witness Signature */}
                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Witness_Signature')}
                                </div>
                                <div className="col-md-9">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        required={false}
                                        requiredMessage={this.getLocalizedText('Signature_Required')}
                                        validateOn={form.witnessSignature}>
                                        <SignatureInput signature={form.witnessSignature}
                                            onClear={() => {
                                                this.fieldChanged('witnessSignature', null)
                                            }}
                                            onSave={(signature) => {
                                                this.fieldChanged('witnessSignature', signature)
                                            }} />
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}
